module.exports = {
    tag: 'magical',
    quality: 0.5,
    mana: 2,
    magicalGravity: 0.3
};